import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { LoginModel } from './login.modelview';
import { LoginProvider } from './login.provider';
import { CadastroPage } from '../cadastro/cadastro';
import { DrawerPage } from '../drawer/drawer';
import { FormBuilder, Validators } from '@angular/forms';
import { HomePage } from '../home/home';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  public loginForm: any;

  model: LoginModel = new LoginModel()

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loginProvider: LoginProvider,
    public formBuilder: FormBuilder,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController) {
    this.loginForm = formBuilder.group({
      email: ['', Validators.compose([Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'), Validators.required])],
      password: ['', Validators.compose([Validators.minLength(6), Validators.required])],
    });

    this.model.email = navParams.get("email")
  }

  ionViewDidLoad() {

  }

  login() {
    let loading = this.loadingCtrl.create({
      content: 'Logando...'
    });
    loading.present()

    this.loginProvider.doLogin(this.model.email, this.model.password).subscribe(() => {
      loading.dismiss().then(() => {
        this.navCtrl.setRoot(HomePage)
      })
    }, err => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: 'Erro ao efetuar o login! Verifique suas credenciais e a sua conexão.',
          showCloseButton: true,
          position: 'bottom'
        });
        toast.present()
      })

    })
  }

  cadastro() {
    this.navCtrl.push(CadastroPage)
  }

  forguetPassword() {
    let loading = this.loadingCtrl.create({
      content: 'Solicitando...'
    });
    loading.present()

    this.loginProvider.forguetPassword(this.model.email).subscribe(() => {
      loading.dismiss().then(() => {
        
      })
    }, err => {
      loading.dismiss().then(() => {
        let toast = this.toastCtrl.create({
          message: 'Erro ao efetuar o login! Verifique suas credenciais e a sua conexão.',
          showCloseButton: true,
          position: 'bottom'
        });
        toast.present()
      })

    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts